<template>
  <div class="discovery-container">
    <div class="sort">
      <span>排序</span>
      <span
        v-for="item in sort"
        :key="item.label"
        :class="{ active: sort_active === item.label }"
        @click="sortClick(item.label)"
        >{{ item.label }}</span
      >
    </div>
    <List
      class="list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getData"
    >
      <Cell class="cell" v-for="item in list" :key="item.id">
        <DataComponent :source="item" />
      </Cell>
    </List>
  </div>
</template>

<script>
import DataComponent from '@/views/Discovery/Index/components/Item'
import { getMaterialByBrandPlace } from '@/api/discovery'
import { List, Cell } from 'vant'
export default {
  components: { DataComponent, List, Cell },
  props: {
    brandId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      list: [],
      finished: false,
      loading: false,
      sort_active: '时间',
      sort: [{ label: '时间' }, { label: '热度' }],
      pagination: {
        page: 0,
        size: 10,
      },
    }
  },
  methods: {
    getData() {
      const params = {
        brandId: this.brandId
      }
      
      getMaterialByBrandPlace(params)
        .then(res => {
          const data = res.data.map((item) => {
            const obj = { desc_fold: null, desc: item.content, fold: false }
            if (item.content.length > 100) {
              obj.desc_fold = item.content.slice(0, 100)
              obj.fold = false
            }
            return { ...item, ...obj }
          })
          this.list.push(...data)
          this.loading = false
          // if (data.length < this.pagination.size) {
            this.finished = true
          // } else {
          //   this.pagination.page++
          // }
        })
    },
    sortClick(val) {
      this.sort_active = val
      
      this.list = []
      this.pagination.page = 0
      this.finished = false
    },
  }
}
</script>

<style lang="less" scoped>
.discovery-container {
  .sort {
    padding: 0 24px 20px;
    background-color: #fff;
    span {
      display: inline-block;
      padding: 10px 0;
      font-size: 24px;
      font-weight: 400;
      color: #3a3a3a;
      line-height: 24px;
      margin-right: 40px;
      &.active {
        font-weight: 600;
        color: #e82035;
      }
      &:nth-of-type(1) {
        color: #aeaeae;
      }
    }
  }
  .list {
    background-color: #F8F8F8;
  }
  .cell {
    padding: 0;
    & + .cell {
      margin-top: 24px;
    }
    &::after {
      display: none;
    }
    .discovery-item {
      margin-bottom: 0;
    }
  }
}
</style>